import {EventEmitter, Injectable, Output} from '@angular/core';
import {PaymentResponseModel} from '../models/payment-response.model';
import {UserResponseModel} from '../models/user-response.model';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';
import {UserRequestModel} from '../models/user-request.model';

@Injectable()
export class SharedService {

  paymentResponse: PaymentResponseModel = new PaymentResponseModel();

  @Output() getLoggedInName: EventEmitter<any> = new EventEmitter();
  // user: UserResponseModel;

  constructor() {
  }

  setPaymentResponse(paymentResponse: PaymentResponseModel) {
    this.paymentResponse.offerId = paymentResponse.offerId;
    this.paymentResponse.orderId = paymentResponse.orderId;
  }

  getPaymentResponse(): PaymentResponseModel {
    if (this.paymentResponse && this.paymentResponse.orderId && this.paymentResponse.offerId) {
      return this.paymentResponse;
    }

    return null;
  }

  isAuthenticated(): boolean {
    if (this.getPaymentResponse() !== null) {
      return true;
    }

    return false;
  }



  login(user: UserResponseModel): UserResponseModel {
    // function successfulLogIn(user1: UserResponseModel) {
    //   return true;
    // }

   // if (user != null) {
      this.getLoggedInName.emit(user);
      return user;
    // } else {
    //   this.getLoggedInName.emit('Sign In');
    //   return user;
    // }
  }

  logout(): void {
    this.getLoggedInName.emit('Sign In');
  }

}



// WEBPACK FOOTER //
// ./src/app/services/shared.service.ts